import React from 'react';
import DORSigningLinkButton from './DORSigningLinkButton';
import DownloadDORButton from './DownloadDORButton';
import { languageLabels } from '../../claims/claimsHelpers';

interface LanguageOption {
  key: string;
  value: string;
}

interface DORButtonDropdownProps {
  shipmentId: number;
  trackingCode?: string;
  availableDORLanguages: string[];
  isEasyDOREnabled: boolean;
  isDORSigningLinkEnabled: boolean;
  recipientEmail: string;
  reloadSearch?: () => void;
  isDataProcessingConsentAvailable: boolean;
}

function DORButtonDropdown(props: DORButtonDropdownProps) {
  const {
    shipmentId,
    trackingCode,
    availableDORLanguages,
    isEasyDOREnabled,
    isDORSigningLinkEnabled,
    recipientEmail,
    reloadSearch,
    isDataProcessingConsentAvailable,
  } = props;

  const mappedAvailableLanguages: LanguageOption[] = availableDORLanguages
    .map((language) => ({ key: language, value: languageLabels[language] || language.toUpperCase() }))
    .sort((a, b) => a.value.localeCompare(b.value));

  return (
    <>
      {isDORSigningLinkEnabled && (
        <DORSigningLinkButton
          languages={mappedAvailableLanguages}
          recipientEmail={recipientEmail}
          shipmentId={shipmentId}
          reloadSearch={reloadSearch}
          isDataProcessingConsentAvailable={isDataProcessingConsentAvailable}
        />
      )}
      {isEasyDOREnabled && (
        <DownloadDORButton
          languages={mappedAvailableLanguages}
          shipmentId={shipmentId}
          trackingCode={trackingCode}
          isDataProcessingConsentAvailable={isDataProcessingConsentAvailable}
        />
      )}
    </>
  );
}

export default React.memo(DORButtonDropdown);
